import React, { useMemo, useCallback } from "react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@shadcn-in-nx/ui/select";
import { useChatContext } from "../ChatContext";

const PageSelector = () => {
    const {
        components,
        selectedPageId,
        setSelectedPageId,
        iframePageId,
        setIframePageId,
    } = useChatContext();

    // Filter for pages
    const pages = useMemo(() => {
        if (!components || !components.length) return [];
        return components.filter((c) => {
            const filePath = c.filePath || "";
            return (
                filePath.endsWith(".jsx") &&
                (filePath.includes("pages") || filePath.includes(".page"))
            );
        });
    }, [components]);

    // Display the iframe-reported page if available, otherwise the user-selected page
    const displayValue = iframePageId || selectedPageId || "";

    // When user picks from dropdown, drive navigation and clear iframe override
    const handlePageChange = useCallback(
        (value) => {
            setIframePageId(null);
            setSelectedPageId(value);
        },
        [setSelectedPageId, setIframePageId]
    );

    if (pages.length === 0) {
        return null;
    }

    return (
        <Select value={displayValue} onValueChange={handlePageChange}>
            <SelectTrigger className="w-full md:w-[140px] lg:w-[180px] xl:w-[200px] h-8 bg-white">
                <SelectValue placeholder="/" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value={"/"}>/</SelectItem>
                {pages.map((page) => (
                    <SelectItem key={page.id} value={page.id}>
                        {page.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};

export default React.memo(PageSelector);
